import { makeStyles } from '@material-ui/core/styles';

const useDetectionStyles = makeStyles(() => {
    const style = {};	

    style['detection-fb-typo'] = {
        fontFamily: 'Roboto',
        fontWeight: 400, 
        fontSize: '32px', 
        marginBottom: '20px'
    }

    style['detection-fb-canvas'] = {
        width: 'auto',
        maxHeight: '225px',
        overflow: 'scroll',
        border: "1px solid #DDDDDD",
        margin: "10px 0 20px 0"
    }

    style['w_100'] = {
        width: '100%'
    }

    style['fb-loading']={
        display: 'flex',
        flexDirection: 'column',
        padding: '10px',
        alignItems: 'center',
        justifyContent: 'center',    
    }

    style['flex-row'] = {
        display: 'flex',
        flexDirection: 'row',
    }

    style['ml_17'] = {
        marginLeft: '17px'
    }

    style['mr_25'] = {
        marginRight: '25px'
    }
    
    style['fb-h2'] = {
        fontFamily: 'Roboto', 
        fontWeight: 400, 
        fontSize: '32px', 
        marginBottom: '20px'
    }

    style['grid-loading'] = {
        maxHeight: 'calc(100vh - 300px)',
        height: 'calc(100vh - 320px)',
    }

    style['feed-checkbox'] = {
        padding: '0px 0px 4px 8px',
    }

    style['no-result-found'] = {
        zIndex: 2,
        top: 400,
        width: '100%',
        textAlign: 'center',
    }

    style['doc-preview-shimmer-container'] = {
        width: 600,
        display : 'block',
        margin : '2px auto',
        backgroundColor: '#fff',
        padding: '30px',
        position: 'relative'
    }

    style['pos_rel'] = {
        position: 'relative',
    }
    
    style['white'] = {
        color:'#fff !important',
    }
    
    style['doc-preview-redactions-label-box']={
        display: 'flex',
        alignItems: 'center',
        marginRight: '15px'
    }

    style['doc-preview-container'] = {
        overflow: 'auto',
        whiteSpace: 'nowrap',
        display: 'flex',
        flexDirection: 'column'
    }

    style['doc-preview-img-container'] = {
        margin: 'auto',
        minHeight: 'calc(100vh - 180px)'
    }

    style['img-preview-classifier-tooltip-typo'] = {
        fontSize: '12px', 
        lineHeight: 1.5
    }

    style['data-cell'] = {
        flexDirection: 'column',
        textAlign: 'left',
        textTransform: 'none',
    }

    style['status-renderer-table-cell'] = {
        margin: '2px',
        background: '#EDE3F6',
        border: '0px',
        color: 'black',
    }

    style['font-weight-600'] = {
        fontWeight: 600
    }

    style['detection-sidePanel-loading-container'] = {
        maxHeight: 'calc(100vh - 300px)',
        height: 'calc(100vh - 300px)',
    }

    style['detection-sidePanel-preview-container'] = {
        maxHeight: 'calc(100vh - 100px)',
        overflowY: 'auto',
        overflowX: 'hidden',  
    }

    style['pos-rel'] = {
        position: 'relative'
    }

    style['preview-img-container'] = {
        height: 'calc(100vh - 180px)',
        maxHeight: 'calc(100vh - 180px)',
        overflow: 'auto',
    }

    style['preview-img-btns-container'] = {
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#191919',
        padding: '5px 10px',
        borderRadius: '5px'
    }

    style['gap_20'] = {
        gap: 20
    }

    style['flex-center'] = {
        display: 'flex',
        alignItems: 'center',   
    }

    style['feed-side-preview-shimmer'] = {
        height: 200,
        display: 'block',
        margin: 'auto',
        backgroundColor: '#fff',
        width: '40%',
        position: 'absolute',
        left: 0,
        right: 0,
        padding: '10px 20px'
    }
    style['copy-icon'] = {
        fontSize: '20px !important',
    }
    style['flex'] = {
        display: 'flex',
    }
    return style;

});

export default  useDetectionStyles;